import React, { FC, useState } from "react";
import { Box } from "../../../../../components/box";
import { Table } from "antd";
import { EditDetailModal } from "../pages/export-detail/edit-detail-modal";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { eContent } from "../constant/field-names";

export const ExportList: FC<{
  eRequests: any;
  setERequests: any;
  hiddenEdit?: boolean;
}> = ({ eRequests, setERequests, hiddenEdit }) => {
  const columns = [
    {
      title: "",
      dataIndex: "action",
      key: "action",
      hidden: hiddenEdit,
      render: (value: any, record: any, index: number) => {
        index = (currentPage - 1) * pageSize + index;

        return (
          <>
            <EditDetailModal
              dataSource={eRequests}
              setDataSource={setERequests}
              index={index}
            />
          </>
        );
      },
    },
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      render: (value: number, record: any, index: number) => {
        index = (currentPage - 1) * pageSize + index;

        return <>{index + 1}</>;
      },
    },
    {
      title: "Tên vật tư/hàng hóa",
      dataIndex: eContent.productName,
      key: eContent.productName,
    },
    {
      title: "ĐVT",
      dataIndex: eContent.Dram,
      key: eContent.Dram,
    },
    {
      title: "Số lượng đề nghị",
      dataIndex: eContent.requestedQuantity,
      key: eContent.requestedQuantity,
    },
    {
      title: "Số lượng tồn tại đơn vị",
      dataIndex: eContent.inventoryQuantity,
      key: eContent.inventoryQuantity,
    },
    {
      title: "Thời gian sử dụng",
      dataIndex: eContent.productLifetime,
      key: eContent.productLifetime,
      render: (value: any, record: any, index: number) => (
        <>{getDDMMYYYFormat(value)}</>
      ),
    },
    {
      title: "Ghi chú",
      dataIndex: eContent.note,
      key: eContent.note,
    },
    {
      title: "Số lượng phê duyệt",
      dataIndex: eContent.approvedQuantity,
      key: eContent.approvedQuantity,
    },
  ].filter((item) => !item.hidden);

  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <Box title="Chi tiết">
      <Table
        columns={columns}
        dataSource={eRequests}
        
        pagination={{
          onChange: (page) => {
            setCurrentPage(page);
          },
          current: currentPage,
        }}

        scroll={{
          x: "100vh",
        }}
      />
    </Box>
  );
};
